import {ReactNode} from "react";
import {Box, Colors} from "@bounce/shared/ui";

type Props = {
  children: ReactNode;
};

const PHONE_WIDTH = 320;
const PHONE_HEIGHT = 620;

const PhoneFrame = ({children}: Props) => (
  <Box
    sx={{
      width: PHONE_WIDTH,
      height: PHONE_HEIGHT,
      borderRadius: "40px",
      border: `10px solid ${Colors.grey._900}`,
      backgroundColor: Colors.bw.white,
      boxShadow: "0 6px 24px rgba(0, 0, 0, 0.18)",
      position: "relative",
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
        width: 110,
        height: 22,
        borderRadius: "12px",
        backgroundColor: Colors.grey._900,
        zIndex: 1,
      }}
    />
    <Box
      sx={{
        height: "100%",
        width: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        pt: "44px",
        backgroundColor: Colors.grey._100,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default PhoneFrame;
